import { Col, Dropdown, Text } from 'components';
import { Api } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const SecurityDropdown = (props) => {
  const { title, type, customOptions } = props,
    [selected, setSelected] = useState(null),
    settings = useSelector((state) => state.user?.privacySettings),
    defaultOptions = [
      { type: 'anyone', value: 'Anyone' },
      { type: 'friends', value: 'Friends only' },
      { type: 'noOne', value: 'No one' }
    ],
    options = customOptions || defaultOptions;

  useEffect(() => {
    if (!type) return;
    const found = options.find((opt) => opt.type.includes(settings[type]));

    setSelected(options.find((opt) => opt.type.includes(settings[type])));
  }, [settings]);

  function handleSelect(opt) {
    setSelected(opt);

    if (!type) return;

    setTimeout(() => {
      Api.post('/users/updatePrivacy', { value: opt.type, type });
    }, 300);
  }

  return (
    <Dropdown
      selected={selected}
      handleSelect={(x) => handleSelect(x)}
      marg="0 0 8px"
      options={options}
      {...props}
    />
  );
};

const PrivacyAndSecurity = ({ ref }) => {
  const { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation();

  return (
    <Col wid="100%" marg={isMobile ? '24px 0 180px' : '24px 0 0'}>
      <Text h4 marg="16px 0 12px">
        {t('settings.profilePrivacySettings')}
      </Text>

      <SecurityDropdown title={t('settings.whoCanView')} type="showProfile" />

      <SecurityDropdown title={t('settings.whoCanViewInfo')} type="showInfoTab" />

      <SecurityDropdown title={t('settings.whoCanViewBasicInfo')} type="showInfo" />

      {/* <SecurityDropdown title={t('settings.whoCanViewLocation')} /> */}

      {/* <SecurityDropdown title={t('settings.whoCanViewActivities')} /> */}

      {/* <SecurityDropdown title={t('settings.whoCanShare')} /> */}

      <SecurityDropdown title={t('settings.whoCanViewFriends')} type="showFriends" />

      {/*
         <SecurityDropdown
          title={t('settings.whoCanSendFriends')}
          type='receiveFriendRequest'
        />
      */}

      {/* <SecurityDropdown title={t('settings.whoCanSendMessage')} /> */}

      <SecurityDropdown title={t('settings.whoCanViewPhotos')} type="showContent" />

      {/* <SecurityDropdown title={t('settings.whoCanPokes')} /> */}

      {/* <SecurityDropdown title={t('settings.whoCanViewViewed')} /> */}

      {/* <SecurityDropdown title={t('settings.whoCanTag')} /> */}

      <SecurityDropdown title={t('settings.whoCanSeeDateOfBirth')} type="showBirthday" />

      <Text h4 marg="16px 0 12px">
        {t('settings.profilePrivacySettings')}
      </Text>

      <SecurityDropdown title={t('settings.allowSharing')} />

      <SecurityDropdown title={t('settings.allowMentions')} />

      <SecurityDropdown title={t('settings.allowTags')} noBorder />
    </Col>
  );
};

export default PrivacyAndSecurity;
